import React from 'react';
import styled from 'styled-components';

import ConfiguredReactGridLayout from './ConfiguredReactGridLayout';
import ReportEditorItem from './ReportEditorItem';
import { ImportedWidgetblockEditor } from './ImportedWidgetblockEditor';

const ReportStyledItem = styled.div`
    :hover {
        cursor: pointer;
    }

    width: 100%;
    height: 100%;
`;

export default ({
    containerWidth,
    layout,
    onDrag,
    onDragStop,
    onResize,
    onResizeStop,
    onLayoutChange,
    maxRows,
    items,
    onDelete,
    onStartEditing,
    onToggleLock,
    onDuplicate,
    onStamp,
    timezone,
    onExport,
    exportableWigetblockTypes,
    importedWidgetblocks,
    datasets,
    cfjsons,
    isLoading,
    stage,
    metjwt,
    ...otherProps
}) => {
    return (
        <ConfiguredReactGridLayout
            width={containerWidth}
            layout={layout}
            onDrag={onDrag}
            onDragStop={onDragStop}
            onResize={onResize}
            onResizeStop={onResizeStop}
            onLayoutChange={onLayoutChange}
            maxRows={maxRows}
            isDraggable={true}
            isResizable={true}
            preventCollision={false}
            {...otherProps}
        >
            {items.map((item) => {
                const itemLayout = layout.find((layoutItem) => layoutItem.i === (item.id || item.key));
                const isLocked = itemLayout && itemLayout.static;
                return (
                    <ReportStyledItem className={isLocked ? 'static' : ''} key={item.id || item.key}>
                        <ReportEditorItem
                            onExport={exportableWigetblockTypes.includes(item.type) ? () => onExport({ id: item.id || item.key }) : null}
                            timezone={timezone}
                            key={item.id || item.key}
                            onDelete={() => onDelete(item.id || item.key)}
                            item={item}
                            isLocked={isLocked}
                            onStartEditing={() => onStartEditing(item.id || item.key)}
                            onToggleLock={() => onToggleLock(item.id || item.key)}
                            onDuplicate={() => onDuplicate(item.id || item.key)}
                            datasets={datasets}
                            cfjsons={cfjsons}
                            isLoading={isLoading}
                        />
                    </ReportStyledItem>
                );
            })}
            {importedWidgetblocks.map((importedWidgetblock) => {
                const itemLayout = layout.find((layoutItem) => layoutItem.i === importedWidgetblock.layoutId);
                const isLocked = itemLayout && itemLayout.static;
                return (
                    <ReportStyledItem className={isLocked ? 'static' : ''} key={importedWidgetblock.layoutId}>
                        <ImportedWidgetblockEditor
                            onEdit={() => onStartEditing(importedWidgetblock.layoutId)}
                            key={importedWidgetblock.layoutId}
                            onDelete={() => onDelete(importedWidgetblock.layoutId)}
                            onToggleLock={() => onToggleLock(importedWidgetblock.layoutId)}
                            onStamp={() => onStamp(importedWidgetblock.layoutId)}
                            weatherWidget={importedWidgetblock.weatherWidget}
                            isLocked={isLocked}
                            timezone={timezone}
                            datasets={datasets}
                            cfjsons={cfjsons}
                            isLoading={isLoading}
                            stage={stage}
                            metjwt={metjwt}
                        />
                    </ReportStyledItem>
                );
            })}
        </ConfiguredReactGridLayout>
    );
};
